import { TileState } from "../../../pillar/dashboard/store/state/TileState";
import { ModuleListModel } from "../../models/ModuleListModel";
import { ModuleModel } from "../../models/ModuleModel";

export class ModuleState extends TileState<ModuleListModel, ModuleModel> {
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/state/ModuleState.ts